import React, { useState } from 'react';
import { basePort, headers } from "../../module_auth/AuthService"

const SupportForm = () => {
    const [isSubmitting, setIsSubmitting] = useState(false); // 로딩 상태 관리
    const [formData, setFormData] = useState({
        name: '', email: '', kakaoId: '', address: '', arrivalDate: '',
        message: '', selectedServices: [], supportTypes: ['remote'], agreeContact: false, agreePrivacy: false
    });

    // 상세 서비스 데이터 구조화
    const serviceCategories = [
        {
            name: "IT 취업",
            items: ["IT 기업 취업 및 면접컨설팅"]
        },
        {
            name: "비자",
            items: ["블루카드", "취업비자", "학생비자", "인턴/임시비자"]
        },
        {
            name: "행정/복지",
            items: ["전입신고", "운전면허 교환", "킨더겔트", "유치원(Kita) 및 학교 등록 안내"]
        },
        {
            name: "생활/금융",
            items: ["인터넷/전기/가스", "방송수신료(GEZ)", "의료보험", "은행계좌/슈페어콘토"]
        }
    ];

    const handleSupportTypeChange = (e) => {
        const { checked } = e.target;

        setFormData(prev => ({
            ...prev,
            supportTypes: checked ? ['onsite'] : ['remote'] // 체크하면 직접동행, 아니면 빈 배열
        }));
    };

    const handleCheckboxChange = (service) => {
        setFormData(prev => ({
            ...prev,
            selectedServices: prev.selectedServices.includes(service)
                ? prev.selectedServices.filter(s => s !== service)
                : [...prev.selectedServices, service]
        }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const clickSubmit = (event) => {
        event.preventDefault();

        // 1. 서비스 선택 유효성 검사 (최소 하나 이상)
        if (formData.selectedServices.length === 0) {
            alert("희망하시는 서비스를 최소 하나 이상 선택해 주세요.");
            return;
        }

        // 2. 이름 검증
        if (!formData.name.trim()) {
            alert("신청인 성함을 입력해 주세요.");
            return;
        }

        // 3. 이메일 검증 (형식 체크 포함)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.email.trim()) {
            alert("이메일 주소를 입력해 주세요.");
            return;
        } else if (!emailRegex.test(formData.email)) {
            alert("올바른 이메일 형식이 아닙니다.");
            return;
        }

        // 4. 상담 요청 내용 검증
        if (!formData.message.trim()) {
            alert("상담 요청 내용을 상세히 입력해 주세요.");
            return;
        }

        // 가. 최소 글자 수 제한 (예: 10자 이상)
        if (formData.message.length < 10) {
            alert("상담 내용을 최소 10자 이상 구체적으로 적어주세요. 상세할수록 정확한 상담이 가능합니다.");
            return;
        }

        // 나. 의미 없는 반복 문자열 체크 (예: 'ㅋㅋㅋㅋㅋ', '아아아아아')
        const repeatedCharRegex = /(.)\1{4,}/;
        if (repeatedCharRegex.test(formData.message)) {
            alert("의미 없는 문자가 반복되었습니다. 정상적인 문장으로 작성해 주세요.");
            return;
        }

        // 다. 특정 무의미한 패턴 체크 (예: 단순 숫자나 특수문자만 도배)
        const meaningfulTextRegex = /[가-힣a-zA-Z]{3,}/;
        if (!meaningfulTextRegex.test(formData.message)) {
            alert("질문 내용을 확인해 주세요. 한글 또는 영문 위주로 작성해 주셔야 합니다.");
            return;
        }

        // 5. 유효성 검사 (필수 동의 항목 확인)
        if (!formData.agreeContact || !formData.agreePrivacy) {
            alert("모든 동의 사항에 체크해 주세요.");
            return;
        }

        fetch(basePort + '/request/support', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: formData.name,
                email: formData.email,
                kakaoId: formData.kakaoId,
                address: formData.address,
                arrivalDate: formData.arrivalDate,
                selectedServices: formData.selectedServices,
                supportTypes: formData.supportTypes[0],
                message: formData.message
            })
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(response => {
                // 백엔드 반환 구조에 맞춘 로직
                if (response.validRequest) {
                    alert(response.validationMessage);

                    // 2. 모든 필드 클린업 (초기 상태로 리셋)
                    setFormData({
                        name: '',
                        email: '',
                        kakaoId: '',
                        address: '',
                        arrivalDate: '',
                        message: '',
                        selectedServices: [],
                        supportTypes: ['remote'],
                        agreeContact: false,
                        agreePrivacy: false
                    });

                    // 3. 페이지 상단으로 스크롤 (사용자가 리셋된 폼을 확인하기 좋음)
                    // window.scrollTo({ top: 0, behavior: 'smooth' });
                    window.location.reload();
                } else {
                    alert(response.validationMessage);
                }
            })
            .catch(error => {
                console.error("Error:", error);
                alert("서버 통신 중 오류가 발생했습니다.");
            });
    };

    return (
        <div className="card shadow-sm border-0 mt-4 mx-auto" style={{ maxWidth: '650px' }}>
            <div className="card-body p-4 p-md-5">
                <div className="row mb-5">
                    <div className="col-md-8 col-xl-6 text-center mx-auto">
                        <p className="fw-bold text-success mb-2">Contact</p>
                        <h2 className="fw-bold" style={{ fontFamily: 'Nanum Gothic' }}>서비스 상담문의</h2>
                    </div>
                </div>

                <form>
                    {/* 상세 서비스 선택 영역 */}
                    <div className="mb-5">
                        <label className="form-label fw-bold mb-3 d-block text-primary border-bottom pb-2">
                            희망 서비스 선택 (중복 가능)
                        </label>

                        {serviceCategories.map((cat, idx) => (
                            <div key={idx} className="mb-4">
                                <p className="small fw-bold text-secondary mb-2">● {cat.name}</p>
                                <div className="row g-2">
                                    {cat.items.map((item, i) => (
                                        <div className="col-6" key={i}>
                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id={`item-${idx}-${i}`}
                                                checked={formData.selectedServices.includes(item)}
                                                onChange={() => handleCheckboxChange(item)}
                                            />
                                            <label className="btn btn-outline-secondary w-100 py-2 fs-7 text-start ps-3"
                                                htmlFor={`item-${idx}-${i}`}
                                                style={{ fontSize: '0.85rem' }}>
                                                {formData.selectedServices.includes(item) ? '✓ ' : '+ '} {item}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="mb-5">
                        <label className="form-label fw-bold mb-2 d-block text-primary">
                            직접 동행 희망 여부
                        </label>
                        <p className="small text-muted mb-3">
                            ※ 체크하지 않으면 기본적으로 비대면 리모트 지원(이메일 · 카카오톡 · 전화)으로 진행됩니다.
                        </p>

                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="onsiteSupport"
                                value="onsite"
                                checked={formData.supportTypes.includes('onsite')}
                                onChange={handleSupportTypeChange}
                            />
                            <label className="form-check-label" htmlFor="onsiteSupport">
                                직접 동행 희망 (가능 여부 별도 안내)
                            </label>
                        </div>
                    </div>
                    {/* 인적 사항 입력 */}
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label small fw-bold">신청인 정보</label>
                            <input type="text" name="name" className="form-control mb-2" placeholder="이름" required onChange={handleChange} />
                            <input type="email" name="email" className="form-control mb-2" placeholder="이메일" required onChange={handleChange} />
                            <input type="text" name="kakaoId" className="form-control mb-2" placeholder="휴대폰번호 / 카카오톡 ID" required onChange={handleChange} />
                            <input type="text" name="address" className="form-control mb-2" placeholder="거주지(도시명) / 희망도시" onChange={handleChange} />

                            <input
                                type="text"
                                name="arrivalDate"
                                className="form-control mb-2"
                                placeholder="독일 입국 예정일 (예: 2026년 12월 / 이미 거주 중)"
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-12 mt-3">
                            <label className="form-label small fw-bold">상담 요청 내용</label>
                            <textarea name="message" className="form-control" rows="3" placeholder="구체적인 상담을 위해 현재 상황(예: 입국 예정일, 비자 종류, 가족 동반 여부 등)을 자유롭게 입력해 주세요." onChange={handleChange}></textarea>
                        </div>

                        {/* 동의란 */}
                        <div className="col-12 mt-4 p-3 bg-light rounded" style={{ fontSize: '1rem' }}>
                            <label className="form-label small fw-bold">동의사항</label>
                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" name="agreeContact" id="c1" required onChange={handleChange} />
                                <label className="form-check-label" htmlFor="c1">상담을 위한 연락(이메일/카톡)에 동의합니다.</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="agreePrivacy" id="c2" required onChange={handleChange} />
                                <label className="form-check-label" htmlFor="c2">개인정보 처리방침에 동의합니다.</label>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-100 py-3 mt-4 fw-bold shadow-sm"
                            disabled={isSubmitting} // 전송 중 클릭 방지
                            onClick={clickSubmit}   // 작성한 fetch 함수 연결
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    전송 중...
                                </>
                            ) : '상담 신청하기'}
                        </button>
                        
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SupportForm;